export const PA_Crypto = {

    // Generate a key from a string passcode
    async getKey(passcode, salt) {
        const enc = new TextEncoder();
        const keyMaterial = await window.crypto.subtle.importKey(
            "raw",
            enc.encode(passcode),
            { name: "PBKDF2" },
            false,
            ["deriveKey"]
        );

        return window.crypto.subtle.deriveKey(
            {
                name: "PBKDF2",
                salt: salt, // 🎯 Use the unique salt passed in
                iterations: 100000,
                hash: "SHA-256"
            },
            keyMaterial,
            { name: "AES-GCM", length: 256 },
            false,
            ["encrypt", "decrypt"]
        );
    },

    async encrypt(binaryData, passcode) {
        const enc = new TextEncoder();
        // 🎯 Generate a fresh 16-byte salt for this specific document
        const salt = window.crypto.getRandomValues(new Uint8Array(16));
        const iv = window.crypto.getRandomValues(new Uint8Array(12));

        // Derive the key using the passcode AND the new salt
        const key = await this.getKey(passcode, salt);

        const cipherText = await window.crypto.subtle.encrypt(
            { name: "AES-GCM", iv: iv },
            key,
            binaryData
        );

        return {
            cipherText,
            iv: Array.from(iv),     // Convert to array for JSON/BSON storage
            salt: Array.from(salt)  // Store this so we can derive the same key for decryption later
        };
    },

    async decrypt(encryptedBinary, passcode, ivArray, saltArray) {

        console.log("PA_Crypto.decrypt secret length:", passcode.length);
        console.log("PA_Crypto.decrypt encryptedBinary size:", encryptedBinary.byteLength);


        // 1. Convert the stored arrays back into Uint8Arrays for Web Crypto
        const iv = new Uint8Array(ivArray);
        const salt = new Uint8Array(saltArray);

        // 2. Derive the EXACT same key using the unique salt
        const key = await this.getKey(passcode, salt);

        try {
            // 3. Decrypt the blob
            const decrypted = await window.crypto.subtle.decrypt(
                {
                    name: "AES-GCM",
                    iv: iv
                },
                key,
                encryptedBinary
            );

            return decrypted; // Returns ArrayBuffer
        } catch (err) {
            console.error("Crypto subtle rejected the decryption request.");
            console.error("IV used:", iv);
            console.error("Salt used:", salt);
            console.error("Decryption failed. Likely an incorrect passcode.", err);
            throw new Error("Decryption failed: Invalid key or corrupted data.");
        }
    }
};